import React from 'react'
import styled, { keyframes, ThemeProvider } from 'styled-components'
import { DarkTheme, mediaQueries } from './Themes'

import LogoComponent from '../subComponents/LogoComponent'
import SocialIcons from '../subComponents/SocialIcons'
import ParticleComponent from '../subComponents/ParticleComponent'
import BigTitle from '../subComponents/BigTitlte'
import { YinYang } from './AllSvgs'

const Box = styled.div`
	background-color: ${(props) => props.theme.body};
	width: 100vw;
	height: 100vh;
	position: relative;
	overflow: hidden;
`
const float = keyframes`
0% { transform: translate(0px, 0px);}
20% { transform: translate(5%, 5%);}
40% { transform: translate(0%, 10%); }
60% { transform: translate(5%, 10%); }
80% { transform: translate(-5%, 5%); }
100% { transform: translate(0px, 0px); }

`
const Spaceman = styled.div`
	position: absolute;
	top: 35%;
	right: 5%;
	width: 20vw;
	animation: ${float} infinite 5s linear;
	img {
		width: 100%;
		height: auto;
	}
`
const Main = styled.div`
	border: 2px solid #d89216;
	color: #d89216;
	padding: 2rem;
	width: 50vw;
	height: 60vh;
	z-index: 3;
	line-height: 1.5;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: calc(0.6rem + 1vw);
	backdrop-filter: blur(4px);

	position: absolute;
	left: calc(5rem + 5vw);
	top: 10rem;
	font-family: 'Ubuntu Mono', monospace;
	font-style: italic;

	${mediaQueries(40)`
          width: 60vw;
          height: 50vh;
          top:50%;
          left:50%;
          transform:translate(-50%,-50%);


  `};
	${mediaQueries(30)`
          width: 50vw;
          height: auto;
          backdrop-filter: none;
          margin-top:2rem;

  `};

	${mediaQueries(20)`
          padding: 1rem;
          font-size: calc(0.5rem + 1vw);
  `};
`

const AboutPage = () => {
	return (
		<ThemeProvider theme={DarkTheme}>
			<Box>
				<LogoComponent theme="dark" />
				<SocialIcons theme="dark" />

				<ParticleComponent theme="dark" />

				<Spaceman>
					<YinYang width={240} height={240} fill={'#d89216'} />
				</Spaceman>
				<Main>
					I'm a front-end developer located in Russia. I like to create yet
					beautiful websites with great user experience.
					<br /> <br />
					I'm interested in the whole frontend stack Like trying new things and
					building great projects. My mission is to create an amazing outlook of
					your website, with a clean and responsive code, to bring unique design
					into reality.
					<br /> <br />I believe everything is an Art when you put your
					consciousness in it. You can connect with me via social links.
				</Main>

				<BigTitle text="ABOUT" top="10%" left="5%" />
			</Box>
		</ThemeProvider>
	)
}

export default AboutPage
